module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/store_sakae-551afde38104d9bf185ce6985b1206b7.jpg";